import React, { useContext } from 'react';
import { NoResultFoundSvg, EmptyStateSVG } from './assets';
import { ListContext } from './context';
import { Button } from '../Button';
import { Text } from '../Text';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ErrorMessage() {
  const {
    noSearchListMessage,
    listSearchInputProps,
    noListMessage,
    isNoSearchResult
  } = useContext(ListContext);
  const {
    onReset
  } = listSearchInputProps;
  const isNoSearchResultMessageNode = /*#__PURE__*/React.isValidElement(noSearchListMessage);
  const isNoListMessageNode = /*#__PURE__*/React.isValidElement(noListMessage);
  if (isNoSearchResult && isNoSearchResultMessageNode) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, noSearchListMessage);
  }
  if (!isNoSearchResult && isNoListMessageNode) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, noListMessage);
  }
  const propsObject = isNoSearchResult ? noSearchListMessage : noListMessage;
  const {
    text = isNoSearchResult ? 'We couldn’t find what you’re looking for.' : 'There are no items in this list yet.',
    subtext = isNoSearchResult ? 'Try different keyword.' : '',
    actionButtonProps = isNoSearchResult ? {
      variant: 'secondary',
      label: 'Clear keywords',
      onClick: onReset
    } : {
      variant: 'secondary',
      label: 'Create'
    }
  } = propsObject || {};
  return /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__no-result_content']
  }, /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__no-result_image']
  }, isNoSearchResult ? /*#__PURE__*/React.createElement(NoResultFoundSvg, null) : /*#__PURE__*/React.createElement(EmptyStateSVG, null)), /*#__PURE__*/React.createElement(Text, {
    size: "lg",
    tag: "p",
    fontFamily: "regular",
    color: "var(--sib-color_content-primary)"
  }, text), /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    tag: "span",
    fontFamily: "regular",
    color: "var(--sib-color_content-secondary)"
  }, subtext), /*#__PURE__*/React.createElement(Button, actionButtonProps));
}
export default ErrorMessage;